import { Search } from 'lucide-react';
import { Input } from '@/components/atoms/input';

interface DataTableSearchFilterFieldProps {
  value: string;
  onValueChange: (value: string) => void;
  placeholder: string;
}

export function DataTableSearchFilterField({
  value,
  onValueChange,
  placeholder,
}: DataTableSearchFilterFieldProps) {
  return (
    <div className="relative min-w-0">
      <Search
        size={13}
        className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
      />
      <Input
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        placeholder={placeholder}
        className="h-9 min-w-0 pl-8 text-sm"
      />
    </div>
  );
}
